<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card" *ngIf="addressBook">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-4 col-12" ngClass.sm="mb-1" ngClass.md="mb-1">
            <input type="search" class="form-control" [placeholder]="'SEARCH' | translate" [(ngModel)]="searchKey" (ngModelChange)="filterUsers()" />
          </div>
          <div class="col-lg-4 col-12">
            <ng-select id="figure" [openOnEnter]="false" [virtualScroll]="true" [searchable]="true" (change)="filterUsers()" [closeOnSelect]="true" [clearable]="searchFigure > 0" [(ngModel)]="searchFigure">
              <ng-option [value]="0" [disabled]="true">{{ "SELECT_PROFESSIONAL_FIGURE" | translate }}</ng-option>
              <ng-option *ngFor="let figure of _userFigureService.list" [value]="figure.id">{{ figure.name }}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <section *ngIf="addressBook" class="row" id="users-list">
      <div *ngFor="let user of filteredList" class="col-xl-4 col-lg-6 col-12">
        <div class="card">
          <div class="card-body">
            <figure class="avatar" *ngIf="user.avatar && user.avatar.length > 0" [routerLink]="['/dashboard/user/profile/', user.hash]">
              <img class="rounded img-cover" src="{{ user.avatar }}" alt="{{ user.complete_name }}" />
            </figure>
            <div class="avatar bg-light-primary mr-1 ml-0" *ngIf="!user.avatar || user.avatar.length < 1" [routerLink]="['/dashboard/user/profile/', user.hash]">
              <div class="rounded">{{ user.complete_name | initials }}</div>
            </div>
            <div>
              <a class="font-medium-3 d-block" [routerLink]="['/dashboard/user/profile/', user.hash]">{{ user.complete_name }}</a>
              <div *ngIf="user.figure" class="badge badge-light-secondary mt-05 cursor-pointer" [ngbTooltip]="'PROFESSIONAL_FIGURE' | translate" placement="right" (click)="searchByFigure(user.figure_id)">
                {{ user.figure }}
              </div>
              <div class="links">
                <a *ngIf="user.email" [href]="'mailto:' + user.email" [ngbTooltip]="'USER_OFFICE_EMAIL' | translate">
                  <i [data-feather]="'mail'" size="16" class="mr-50"></i>
                  {{ user.email }}
                </a>
                <a *ngIf="user.public_email" [href]="'tel:' + user.public_email" [ngbTooltip]="'PRIVATE_EMAIL' | translate">
                  <i [data-feather]="'mail'" size="16" class="mr-50"></i>
                  {{ user.public_email }}
                </a>
                <a *ngIf="user.public_phone" [href]="'tel:' + user.public_phone" [ngbTooltip]="'PRIVATE_PHONE' | translate"> <i [data-feather]="'phone'" size="16" class="mr-50"></i> {{ user.public_phone }} </a>
              </div>
              <div class="socials">
                <a *ngFor="let social of user.socials" [href]="social.url" target="_blank" [class]="'mr-1 text-' + social.name" [ngbTooltip]="social.name">
                  <i size="20" [data-feather]="social.name"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
